// The areas of the /hotels page ("Where to stay in Dubai"), in page order:
// each a point on land for Stay22's map and Allez searches, a zoom that frames
// it, and the area's collection page where there is one. Copy: `hotelsPage.areas.<id>`
// in the resources.

import type { Stay } from '@todo/core/hotels';

export type HotelArea = {
  id: string;
  stay: Stay;
  zoom: number;
  /** The area's things-to-do collection (/[lang]/<slug>), if it has one. */
  collection?: string;
};

export const HOTEL_AREAS: readonly HotelArea[] = [
  // Dubai Mall / Burj Khalifa.
  { id: 'downtown', stay: { lat: 25.1972, lng: 55.2797 }, zoom: 14, collection: 'downtown-dubai' },
  { id: 'business-bay', stay: { lat: 25.1865, lng: 55.2645 }, zoom: 14 },
  // Marina Walk, west bank.
  { id: 'dubai-marina', stay: { lat: 25.0782, lng: 55.1395 }, zoom: 14, collection: 'dubai-marina' },
  // The Walk at JBR.
  { id: 'jbr', stay: { lat: 25.0786, lng: 55.1334 }, zoom: 15 },
  // The trunk; the map's zoom shows the fronds and Atlantis.
  { id: 'palm-jumeirah', stay: { lat: 25.1124, lng: 55.139 }, zoom: 13, collection: 'palm-jumeirah' },
  // Madinat Jumeirah / Burj Al Arab.
  { id: 'jumeirah', stay: { lat: 25.1335, lng: 55.1852 }, zoom: 14 },
  // Al Fahidi, Bur Dubai side of the Creek.
  { id: 'old-dubai', stay: { lat: 25.2636, lng: 55.2988 }, zoom: 14, collection: 'old-dubai' },
];

/** The whole city, Jebel Ali to Deira: the map the page opens on. */
export const DUBAI_STAY: Stay = { lat: 25.15, lng: 55.22 };
export const DUBAI_ZOOM = 11;
/** A phone-width map needs one level less to fit the coast. */
export const DUBAI_ZOOM_NARROW = 10;
